import { render, staticRenderFns } from "./ModalFormApproveComponent.vue?vue&type=template&id=27b29074&scoped=true"
import script from "./ModalFormApproveComponent.vue?vue&type=script&lang=js"
export * from "./ModalFormApproveComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalFormApproveComponent.vue?vue&type=style&index=0&id=27b29074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b29074",
  null
  
)

export default component.exports